import { getSchedule, getMatches } from './../api/schedule';
import { dates } from './../static-data/';


const ids = [];

export default function getScheduleData() {
    return new Promise((resolve, reject) => {
        getSchedule()
            .then((json) => {
                if (!json.data && !json.data.data) {
                    resolve([]);
                    return;
                }
                const schedule = [];
                dates.map(data => schedule.push(data));
                json.data.data.forEach(event => ids.push(event._id));
                const dateObj = convertToDateKeysObj(json.data.data);

                const days = scheduleAsDays(schedule, dateObj);
                const sports = convertToTypeKeysObj(json.data.data);

                if (ids.length) {
                    getMatches(ids).then((response) => {
                        if (!response.data) return;
                        const events = addMatchesData(response.data);
                        resolve({ days, sports, events });
                    });
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
}

// Добавляет данные матча
function addMatchesData(matches) {
    const result = {};
    ids.forEach((id) => {
        if (!matches[id] || !matches[id].data) return false;
        const match = matches[id].data;
        const selectedFields = {};

        if (match.stadium) {
            selectedFields.stadium = {
                name: match.stadium.name || '',
                city: match.stadium.city || '',
                country: match.stadium.country_name || ''
            };
        }

        if (match.result && match.result.top && match.result.top.length) {
            selectedFields.top = [];
            match.result.top.forEach((player) => {
                selectedFields.top.push({
                    country: player.country || '',
                    player: player.player || '',
                    result: player.result || ''
                });
            });
        }

        const participants = findParticipants(match.name);
        if (participants.length) {
            selectedFields.participants = participants.map(participant => (
                { country: participant }
            ));
        }
        selectedFields.id = match._id || '';
        selectedFields.name = match.name || '';
        selectedFields.type = match.group ? (match.group.name || '') : '';
        selectedFields.typeID = match.group ? (match.group.id.toString() || '') : '';
        selectedFields.time = {
            start: match.time || '',
            finish: ''
        };
        selectedFields.status = match.flags && match.flags.is_played === 1 ? 'E' : 'N';
        selectedFields.isSummary = match.flags && match.flags.is_summary === 1;
        selectedFields.isLive = false;
        selectedFields.link = '';
        selectedFields.date = parseDateFromString(match.date_str);

        selectedFields.original = match;
        selectedFields.original.ch = match;
        result[id] = selectedFields;
    });

    return result;
}

// Принимает массив дат и объект с массивами событий
// по дням
function scheduleAsDays(sourceArr, keyValueDaysObj) {
    return sourceArr.map((item, index) => {
        const day = item;
        const formattedDate = convertDateToString(item.date);
        day.id = index;
        day.isOpen = false;
        day.events = keyValueDaysObj[formattedDate].map(event => event._id);
        return day;
    });
}

// Принимает строку, ищет в ней участников по паттерну "Участник1 - Участник2"
// Возвращает массив участников или пустой массив
function findParticipants(str) {
    const searchResult = str.match(/(\.|:)\s[^.|^:]+\s-\s.+$/);
    if (!searchResult) return [];
    const clearedSearchStr = searchResult[0].slice(2);
    const arrResults = clearedSearchStr.split(' - ');
    return arrResults.length ? arrResults : [];
}

// Преобразует массив данных в объект с ключами в виде дат
function convertToDateKeysObj(arr) {
    const result = {};
    arr.forEach((element) => {
        if (!element.date) return false;

        if (!result[element.date]) {
            result[element.date] = [];
        } else {
            result[element.date].push(element);
        }
    });
    return result;
}
// Преобразует массив данных в объект с ключами в виде названий видов спорта
function convertToTypeKeysObj(arr) {
    const result = {};

    arr.forEach((element) => {
        if (!element.group && !element.group.name) return false;
        const type = element.group.name;
        const date = element.date ? element.date.slice(-2) : '';
        if (!result[type]) {
            result[type] = {
                [date]: {
                    showCard: false,
                    events: [element._id]
                }
            };
        } else if (!result[type][date]) {
            result[type][date] = {
                showCard: false,
                events: [element._id]
            };
        } else {
            result[type][date].events.push(element._id);
        }
    });
    return result;
}

function convertDateToString(dateNum) {
    const prefix = '2018-02-';
    if (dateNum < 10) {
        return `${prefix}0${dateNum}`;
    }
    return `${prefix}${dateNum}`;
}

function parseDateFromString(str) {
    const result = {
        day: 0,
        month: '',
        weekDay: ''
    };

    if (!str) return result;
    const dataSeparated = str.split(' ');
    result.day = parseInt(dataSeparated[0], 10) || 0;
    result.month = dataSeparated[1];
    let weekDay = '';
    if (dataSeparated[4][dataSeparated[4].length - 1] === '.') {
        weekDay = dataSeparated[4].slice(0, -1);
    } else {
        weekDay = dataSeparated[4];
    }
    result.weekDay = weekDay;
    return result;
}



// WEBPACK FOOTER //
// ./src/middlewares/schedule.js